import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const crmWinProbabilityWidget: DashboardWidgetConfiguration = {
  widgetId: "crm.win-probability",
  name: "Average win probability",
  description: "Average win probability with bounded dashboard time windows.",
  apps: [
    "home",
    "crm",
  ],
  template: "percentage",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "crm.prospects",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "avg",
          field: "probability",
          as: "probability",
        },
      ],
      where: {
        type: "condition",
        field: "prospect_type",
        operator: "eq",
        value: "opportunity",
      },
    },
  },
  inputs: {
    title: "Win probability",
    caption: "Opportunity confidence",
    presentation: "bar",
    color: "#206bc4",
  },
  dummyData: {
    value: "64.2%",
    change: "+3.8%",
  },
  limits: {
    minWidth: 3,
    maxWidth: 6,
    minHeight: 2,
    maxHeight: 4,
    defaultWidth: 4,
    defaultHeight: 2,
  },
};
